import { render, staticRenderFns } from "./v-quote.vue?vue&type=template&id=10d6986a&scoped=true&"
import script from "./v-quote.vue?vue&type=script&lang=js&"
export * from "./v-quote.vue?vue&type=script&lang=js&"
import style0 from "./v-quote.vue?vue&type=style&index=0&id=10d6986a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d6986a",
  null
  
)

export default component.exports